(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["helion-canguru-editorial"] && !Shopify.designMode) return;
  try {
    
(() => {
  const allRoots = document.querySelectorAll('[data-hc-product-root]');
  const money = (cents) => new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format(cents / 100);
  allRoots.forEach(root => {
    if(root.dataset.hcInitialized==='true') return;
    root.dataset.hcInitialized='true';
    const variantsNode=root.querySelector('[data-hc-variants-json]');
    if(!variantsNode) return;
    let variants=[];
    try { variants=JSON.parse(variantsNode.textContent); } catch(e) { return; }
    const colors=[...root.querySelectorAll('[data-hc-color]')];
    const sizes=[...root.querySelectorAll('[data-hc-size]')];
    const thumbs=[...root.querySelectorAll('[data-hc-thumb]')];
    const mainImg=root.querySelector('.hc-main-image');
    const imageCount=root.querySelector('[data-hc-image-counter]');
    const form=root.querySelector('.hc-product-form');
    const variantInput=root.querySelector('[data-hc-variant-id]');
    const btn=root.querySelector('[data-hc-add-button]');
    let current=variants.find(v=>String(v.id)===variantInput?.value)||variants[0];
    let activeIndex=Math.max(0,thumbs.findIndex(x=>x.classList.contains('is-active')));
    function setImage(index){
      if(!mainImg||!thumbs.length) return;
      activeIndex=(index+thumbs.length)%thumbs.length;
      const thumb=thumbs[activeIndex];
      const url=thumb.dataset.url;
      if(url&&mainImg.getAttribute('src')!==url){mainImg.classList.add('is-changing');mainImg.src=url;mainImg.removeAttribute('srcset');mainImg.onload=()=>mainImg.classList.remove('is-changing');mainImg.onerror=()=>mainImg.classList.remove('is-changing');}
      thumbs.forEach((t,i)=>{t.classList.toggle('is-active',i===activeIndex);t.setAttribute('aria-pressed',String(i===activeIndex));});
      if(imageCount) imageCount.textContent=String(activeIndex+1).padStart(2,'0')+' / '+String(thumbs.length).padStart(2,'0');
    }
    thumbs.forEach((t,i)=>t.addEventListener('click',()=>setImage(i)));
    root.querySelector('[data-hc-prev]')?.addEventListener('click',()=>setImage(activeIndex-1));
    root.querySelector('[data-hc-next]')?.addEventListener('click',()=>setImage(activeIndex+1));
    function updateVariant(v){
      if(!v) return;
      current=v;
      if(variantInput) variantInput.value=String(v.id);
      const price=money(v.price);
      root.querySelectorAll('[data-hc-price]').forEach(x=>x.textContent=price);
      root.querySelectorAll('[data-hc-sticky-price]').forEach(x=>x.textContent=price);
      const colorText=root.querySelector('[data-hc-color-text]');if(colorText)colorText.textContent=v.color;
      colors.forEach(b=>{const selected=b.dataset.hcColor===v.color;b.classList.toggle('is-selected',selected);b.setAttribute('aria-pressed',String(selected));});
      sizes.forEach(b=>{const selected=b.dataset.hcSize===v.size;b.classList.toggle('is-selected',selected);b.setAttribute('aria-pressed',String(selected));});
      if(btn)btn.disabled=!v.available;
      const btnLabel=root.querySelector('[data-hc-button-text]');if(btnLabel)btnLabel.textContent=v.available?'Adicionar ao carrinho':'INDISPONÍVEL';
      const status=root.querySelector('[data-hc-status]');if(status)status.textContent=v.available?'Preço e disponibilidade atualizados para esta combinação':'Esta combinação está indisponível';
      const matchingThumb=thumbs.findIndex(x=>String(x.dataset.mediaId)===String(v.mediaId));
      if(matchingThumb>=0) setImage(matchingThumb);
      try {const u=new URL(window.location.href);u.searchParams.set('variant',String(v.id));history.replaceState(history.state,'',u.toString());}catch(e){}
    }
    function choose(color,size){
      const exact=variants.find(v=>v.color===color&&v.size===size);
      if(exact) updateVariant(exact);
    }
    colors.forEach(b=>b.addEventListener('click',()=>choose(b.dataset.hcColor,current?.size)));
    sizes.forEach(b=>b.addEventListener('click',()=>choose(current?.color,b.dataset.hcSize)));
    if(current) updateVariant(current);
    const sticky=root.querySelector('[data-hc-mobile-sticky]');
    const primary=root.querySelector('[data-hc-add-button]');
    if(sticky&&primary){
      const syncSticky=()=>{
        const visible=primary.getBoundingClientRect().bottom<0 && window.scrollY>180;
        sticky.classList.toggle('is-visible',visible);
        sticky.setAttribute('aria-hidden',String(!visible));
      };
      window.addEventListener('scroll',syncSticky,{passive:true});
      window.addEventListener('resize',syncSticky);
      syncSticky();
      root.querySelector('[data-hc-sticky-cta]')?.addEventListener('click',()=>{
        if(!current?.available){root.querySelector('.hc-buy-column')?.scrollIntoView({behavior:'smooth',block:'center'});return;}
        if(form?.requestSubmit) form.requestSubmit(primary); else primary?.click();
      });
    }
    if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches&&'IntersectionObserver' in window){
      root.classList.add('hc-js');
      const revealObserver=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('hc-visible');revealObserver.unobserve(e.target);}})},{threshold:.07,rootMargin:'0px 0px -15px 0px'});
      root.querySelectorAll('.hc-reveal').forEach(n=>revealObserver.observe(n));
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
